/**
 * User Module Constants
 *
 * Constantes centralizadas para o módulo de usuário
 */

// ============================================================================
// Password Validation Rules
// ============================================================================

export const PASSWORD_RULES = {
  minLen: 8,
  upper: /[A-Z]/,
  lower: /[a-z]/,
  digit: /\d/,
  special: /[!@#$%^&*(),.?":{}|<>]/,
} as const;

export const PASSWORD_ERROR_MESSAGES = {
  minLength: 'A senha deve ter pelo menos 8 caracteres',
  uppercase: 'A senha deve conter ao menos uma letra maiúscula',
  lowercase: 'A senha deve conter ao menos uma letra minúscula',
  digit: 'A senha deve conter ao menos um número',
  special: 'A senha deve conter ao menos um caractere especial (!@#$%^&*(),.?":{}|<>)',
  mismatch: 'A confirmação de senha não confere',
} as const;

// ============================================================================
// User Profile Sections
// ============================================================================

export const PROFILE_SECTIONS = {
  dashboard: 'Dashboard de Uso',
  personalInfo: 'Dados Pessoais',
  security: 'Segurança',
  activity: 'Atividade Recente',
} as const;

// ============================================================================
// Usage Status
// ============================================================================

export const USAGE_STATUS = {
  healthy: { label: 'Saudável', color: '#10b981', threshold: 50 },
  warning: { label: 'Atenção', color: '#f59e0b', threshold: 80 },
  critical: { label: 'Crítico', color: '#ef4444', threshold: 100 },
} as const;

// ============================================================================
// Activity Types
// ============================================================================

export const ACTIVITY_TYPES = {
  chat: { icon: '💬', label: 'Conversa' },
  document: { icon: '📄', label: 'Documento' },
  project: { icon: '📁', label: 'Projeto' },
  agent: { icon: '🤖', label: 'Agente' },
} as const;

// ============================================================================
// Placeholders
// ============================================================================

export const PLACEHOLDERS = {
  personalPreferences: 'Nos conte suas preferências para melhor atendê-lo... (Em breve)',
  newPassword: 'Digite sua nova senha',
  confirmPassword: 'Confirme sua nova senha',
} as const;

// ============================================================================
// Success Messages
// ============================================================================

export const SUCCESS_MESSAGES = {
  passwordUpdated: 'Senha atualizada com sucesso',
  profileUpdated: 'Perfil atualizado com sucesso',
} as const;

// ============================================================================
// Error Messages
// ============================================================================

export const ERROR_MESSAGES = {
  fetchProfile: 'Falha ao carregar dados do usuário',
  updatePassword: 'Falha ao atualizar senha',
  updateProfile: 'Falha ao atualizar perfil',
  generic: 'Ocorreu um erro. Por favor, tente novamente.',
} as const;

// ============================================================================
// Loading Messages
// ============================================================================

export const LOADING_MESSAGES = {
  fetchingProfile: 'Carregando informações do perfil...',
  updatingPassword: 'Atualizando senha...',
  updatingProfile: 'Atualizando perfil...',
} as const;

// ============================================================================
// Button Labels
// ============================================================================

export const BUTTON_LABELS = {
  updatePassword: 'Atualizar Senha',
  updateProfile: 'Salvar Alterações',
  cancel: 'Cancelar',
  edit: 'Editar',
} as const;

// ============================================================================
// Types
// ============================================================================

export type PasswordRule = keyof typeof PASSWORD_RULES;
export type ProfileSection = keyof typeof PROFILE_SECTIONS;
export type UsageStatusKey = keyof typeof USAGE_STATUS;
export type ActivityType = keyof typeof ACTIVITY_TYPES;
